(function HotelEngineComparison($, Adzuki)
{
	'use strict';

	const component = {
		emits: ['clear-checkbox'],
		props: {
			hotelsToCompare: {
				type    : Array,
				required: true,
			},
		},
		template: '#he-comparison',
		data() {
			return {
				baseUri    : Adzuki.base_uri,
				localHotels: [],
				showCompRow: true,
			};
		},
		computed: {
		},
		methods: {
			formatCurrency(amount) {
				return new Intl.NumberFormat('en-US', {
					style   : 'currency',
					currency: 'USD'
				}).format(amount);
			},
			formatDate(
				date,
				locale = "en-US",
				options = {
					year : "numeric",
					month: "long",
					day  : "numeric"
				}
			) {
				if (!date) {
					return "";
				}

				try {
					const parsedDate = new Date(date + "T00:00:00Z");
					return new Intl.DateTimeFormat(
						locale, {
							...options,
							timeZone: "UTC"
						}
					).format(parsedDate);
				} catch (error) {
					console.error("Error formatting date:", error);
					return "";
				}
			},
			removeLocalHotel(hotelId) {
				const index = this.localHotels.findIndex(hotel => hotel.hotel_id === hotelId);

				if (index !== -1) {
					this.localHotels.splice(index, 1);
				}

				this.$emit('clear-checkbox', hotelId);
			},
			clearComparison() {
				[...this.localHotels].forEach((hotel) => {
					this.removeLocalHotel(hotel.hotel_id);
				});
			}
		},
		watch: {
			hotelsToCompare: {
				immediate: true,
				deep     : true,
				handler(newValue) {
					this.localHotels = [...newValue];
				}
			},
		},
	};

	Adzuki.VueComponents.HotelEngineComparison = component;
}(jQuery, window.Adzuki || {}));
